<p-card>
  <div class="mb-3"><strong>Media</strong></div>
  <div class="grid">
    <div class="col">
      <p-floatlabel variant="on">
        <p-select
          #substrateSelect
          appLockInitialWidth
          [options]="filteredSubstrates"
          [(ngModel)]="substrateItem.substrateId"
          fluid="true"
          data-testid="substrate"
          optionLabel="text"
          optionValue="id"
          filter="true"
          appendTo="body"
          filterPlaceholder="Search Media"
          class="required"
          [disabled]="isDisabled || editingInstance"
          (onChange)="onSubstrateChange($event)">
        </p-select>
        <label for="on_label">Media</label>
      </p-floatlabel>
    </div>
  </div>
  <div class="grid">
    <div class="col">
      <div class="flex align-content-center flex-wrap">
        <div class="flex align-items-center justify-content-center mr-5">
          <label for="active" style="padding-right: 1rem"
            >Standard:
            <i
              class="fa fa-circle-question"
              style="cursor: pointer; margin-left: 0.5rem"
              pTooltip="{{ standardTooltipText }}"
              tooltipPosition="right">
            </i>
          </label>
          <p-toggleswitch
            [(ngModel)]="substrateItem.standard"
            data-testid="standard"
            (onChange)="onStandardToggle($event)"
            [disabled]="standardToggleDisabled" />
        </div>
        <div class="flex align-items-center justify-content-center">
          {{ substrateItem.customAmount }}{{ substrateItem.customUnit }} per {{ selectedContainerTypeName }}
        </div>
      </div>
    </div>
  </div>
  <div class="grid">
    <div class="col">
      <div class="flex align-content-center flex-wrap">
        <div class="flex align-items-center justify-content-center mr-2">
          <p-floatlabel variant="on">
            <p-inputnumber
              [useGrouping]="false"
              [(ngModel)]="substrateItem.customAmount"
              class="width-6 required"
              inputId="amount"
              data-testid="amount"
              aria-labelledby="amountLabel"
              allowNumbersOnly
              [disabled]="substrateItem.standard"
              (onInput)="emitSubstrateItem()"
              mode="decimal"
              [minFractionDigits]="0"
              [maxFractionDigits]="3" />
            <label id="amountLabel" for="amount">Amount</label>
          </p-floatlabel>
        </div>
        <div class="flex align-items-center justify-content-center flex-grow-1">
          <p-floatlabel variant="on" class="w-full">
            <p-select
              [options]="units"
              [(ngModel)]="substrateItem.customUnit"
              data-testid="customUnit"
              optionLabel="name"
              optionValue="name"
              filter="true"
              appendTo="body"
              filterPlaceholder="Search Unit"
              [disabled]="substrateItem.standard"
              (onChange)="emitSubstrateItem()"
              class="w-full required">
            </p-select>
            <label for="on_label">Unit</label>
          </p-floatlabel>
        </div>
      </div>
    </div>
  </div>
</p-card>
